module.exports = __webpack_public_path__ + "img/google-play.69f096df.png";